/* eslint-disable */
import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: { input: string; output: string };
  JSON: { input: any; output: any };
  /** The `LocalDate` scalar type represents a ISO date string, represented as UTF-8 character sequences YYYY-MM-DD. The scalar follows the specification defined in RFC3339 */
  LocalDate: { input: any; output: any };
  UUID: { input: string; output: string };
};

export type Address = {
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  line2: Maybe<Scalars['String']['output']>;
  region: Maybe<Scalars['String']['output']>;
  street: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type AddressNullable = {
  city: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  line2: Maybe<Scalars['String']['output']>;
  region: Maybe<Scalars['String']['output']>;
  street: Maybe<Scalars['String']['output']>;
  zipCode: Maybe<Scalars['String']['output']>;
};

/** Defines when a policy shall be executed. */
export type ApplyPolicy =
  /** After the resolver was executed. */
  | 'AFTER_RESOLVER'
  /** Before the resolver was executed. */
  | 'BEFORE_RESOLVER'
  /** The policy is applied in the validation step before the execution. */
  | 'VALIDATION';

export type Appointment = {
  createdAt: Scalars['DateTime']['output'];
  createdById: Scalars['String']['output'];
  host: Employee;
  hostId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  note: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  type: Scalars['String']['output'];
  visitor: Patient;
  visitorId: Scalars['String']['output'];
};

export type AppointmentDailyEventsStatusCount = {
  date: Scalars['DateTime']['output'];
  statusesCount: Array<AppointmentEventsStatusCount>;
};

export type AppointmentEvent = {
  appointment: Appointment;
  appointmentId: Scalars['String']['output'];
  careHome: Maybe<CatalogCareHome>;
  careHomeId: Maybe<Scalars['String']['output']>;
  encounter: Maybe<Encounter>;
  group: EventGroupId;
  host: Employee;
  hostId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  period: PeriodOfDateTimeOffset;
  recurrence: Maybe<Recurrence>;
  reference: Maybe<AppointmentTypeTemplate>;
  referenceId: Maybe<Scalars['String']['output']>;
  status: AppointmentEventStatus;
  tenantId: Scalars['String']['output'];
  title: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  visitor: Patient;
  visitorId: Scalars['String']['output'];
};

export type AppointmentEventStatus =
  | 'Attended'
  | 'Cancelled'
  | 'InProgress'
  | 'LateCancelled'
  | 'NoShow'
  | 'Scheduled';

export type AppointmentEventsStatusCount = {
  count: Scalars['Int']['output'];
  status: AppointmentEventStatus;
};

export type AppointmentRequest = {
  createdAt: Scalars['DateTime']['output'];
  declinedNote: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  note: Maybe<Scalars['String']['output']>;
  requestedPeriod: Maybe<PeriodOfDateTimeOffset>;
  status: AppointmentRequestStatus;
  tenantId: Scalars['String']['output'];
  visitorRefs: Array<VisitorRefGraphQl>;
};

export type AppointmentRequestStatus = 'Active' | 'Cancelled' | 'Completed' | 'Declined';

export type AppointmentTypeTemplate = {
  archived: Scalars['Boolean']['output'];
  consentTemplateIds: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  durationInMinutes: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['UUID']['output'];
  status: AppointmentTypeTemplateStatus;
};

export type AppointmentTypeTemplateStatus = 'ACTIVE' | 'INACTIVE';

export type Availability = {
  hostId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  period: PeriodOfDateTimeOffset;
};

export type CatalogCareHome = {
  address: Maybe<Address>;
  archived: Scalars['Boolean']['output'];
  email: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  note: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['UUID']['output'];
  phone: Maybe<Scalars['String']['output']>;
  providerId: Maybe<Scalars['UUID']['output']>;
  type: CatalogCareHomeType;
};

export type CatalogCareHomeType = 'PHYSICAL' | 'TELEHEALTH';

export type Connection = {
  chatId: Scalars['UUID']['output'];
  employeeId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  organizationId: Scalars['UUID']['output'];
  patientId: Scalars['UUID']['output'];
};

export type Consent = {
  assignee: Maybe<Patient>;
  assigneeId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  createdById: Scalars['String']['output'];
  data: Scalars['String']['output'];
  eSignature: Maybe<ESignature>;
  encounter: Maybe<Encounter>;
  id: Scalars['String']['output'];
  isMandatory: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  referenceId: Scalars['String']['output'];
  signatureType: Maybe<ConsentSignatureType>;
  signedAt: Maybe<Scalars['DateTime']['output']>;
  signedBy: Maybe<User>;
  signerDetails: Maybe<ConsentSignerDetails>;
  status: ConsentStatus;
  tenantId: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type ConsentSignatureType = 'CHECKBOX' | 'SIGNATURE';

export type ConsentSignerDetails = {
  address: AddressNullable;
  name: Scalars['String']['output'];
  relation: Maybe<Scalars['String']['output']>;
  role: ConsentSignerRole;
};

export type ConsentSignerRole = 'CARER_OF_PATIENT' | 'NEXT_OF_KIN' | 'PATIENT';

export type ConsentStatus = 'NOT_SIGNED' | 'SIGNED';

export type ConsentTemplate = {
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  createdById: Scalars['String']['output'];
  data: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isAssigneeSignatureRequired: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  isMandatory: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  signatureType: Maybe<ConsentSignatureType>;
  tenantId: Scalars['String']['output'];
};

export type DayOfWeek = 'Friday' | 'Monday' | 'Saturday' | 'Sunday' | 'Thursday' | 'Tuesday' | 'Wednesday';

export type DocumentTag = {
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['UUID']['output'];
};

export type ESignature = {
  meta: ESignatureMeta;
  note: Maybe<Scalars['String']['output']>;
  signature: Scalars['String']['output'];
  signedBy: User;
  signedById: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type ESignatureMeta = {
  ipAddress: Maybe<Scalars['String']['output']>;
};

export type Employee = IUser & {
  account: Maybe<UserAccount>;
  active: Scalars['Boolean']['output'];
  appointmentHostPreferences: Maybe<HostPreferences>;
  avatar: Maybe<Scalars['String']['output']>;
  careHomeId: Maybe<Scalars['UUID']['output']>;
  connection: Maybe<Connection>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  lastAppointment: Maybe<LastAppointment>;
  lastName: Scalars['String']['output'];
  locale: Scalars['String']['output'];
  notificationSettings: Array<NotificationSetting>;
  organizationId: Scalars['UUID']['output'];
  phone: Maybe<Scalars['String']['output']>;
  providerInfo: Maybe<ProviderInfo>;
  roles: Array<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type Encounter = {
  appointment: Maybe<EncounterAppointment>;
  completedOn: Maybe<Scalars['DateTime']['output']>;
  disabled: Scalars['Boolean']['output'];
  eSignatures: Array<ESignature>;
  examination: Maybe<Scalars['JSON']['output']>;
  glaucomaTestAttempts: Array<GlaucomaTestAttempt>;
  glaucomaTests: Maybe<GlaucomaTests>;
  history: Maybe<Scalars['JSON']['output']>;
  id: Scalars['UUID']['output'];
  note: Maybe<Scalars['JSON']['output']>;
  organization: Organization;
  organizationId: Scalars['UUID']['output'];
  patient: Patient;
  patientId: Scalars['UUID']['output'];
  /** Most recent prior visit for this patient; null if none. */
  previousEncounter: Maybe<Encounter>;
  provider: Employee;
  providerId: Scalars['UUID']['output'];
  status: EncounterStatus;
  summary: Maybe<Scalars['JSON']['output']>;
  version: Scalars['String']['output'];
};

export type EncounterAppointment = {
  careHome: CatalogCareHome;
  careHomeId: Scalars['UUID']['output'];
  eventId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  period: PeriodOfDateTimeOffset;
  templateId: Maybe<Scalars['UUID']['output']>;
  title: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type EncounterNote = {
  value: Scalars['JSON']['output'];
};

export type EncounterStatus = 'COMPLETED' | 'DISCARDED' | 'IN_PROGRESS';

export type EncounterTemplate = {
  directory: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  note: Scalars['JSON']['output'];
  organizationId: Scalars['UUID']['output'];
  providerId: Maybe<Scalars['UUID']['output']>;
  root: Scalars['String']['output'];
};

export type EventGroupId = {
  end: Maybe<Scalars['LocalDate']['output']>;
  id: Scalars['UUID']['output'];
  offset: Scalars['Int']['output'];
  start: Scalars['LocalDate']['output'];
};

export type FullNameNullable = {
  firstName: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  middleName: Maybe<Scalars['String']['output']>;
};

export type GlaucomaTestAttempt = {
  id: Scalars['UUID']['output'];
  requestedAt: Scalars['DateTime']['output'];
  resultReceivedAt: Maybe<Scalars['DateTime']['output']>;
  teleportId: Scalars['String']['output'];
};

export type GlaucomaTests = {
  portalUrl: Maybe<Scalars['String']['output']>;
};

export type HostPreferences = {
  defaultAppointmentDurationMinutes: Scalars['Int']['output'];
  hostId: Scalars['String']['output'];
};

export type HostSlotList = {
  hostId: Scalars['String']['output'];
  slots: Array<Slot>;
};

export type IUser = {
  account: Maybe<UserAccount>;
  active: Scalars['Boolean']['output'];
  avatar: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  lastName: Scalars['String']['output'];
  roles: Array<Scalars['String']['output']>;
};

export type LastAppointment = {
  hostId: Scalars['String']['output'];
  last: LastAppointmentValue;
  lastAttended: Maybe<LastAppointmentByTypeValue>;
  visitorId: Scalars['String']['output'];
};

export type LastAppointmentByTypeValue = {
  appointmentId: Scalars['String']['output'];
  period: PeriodOfDateTimeOffset;
};

export type LastAppointmentValue = {
  appointmentId: Scalars['String']['output'];
  period: PeriodOfDateTimeOffset;
  status: AppointmentEventStatus;
};

export type ListSegmentOfCatalogCareHome = {
  items: Array<CatalogCareHome>;
  total: Scalars['Int']['output'];
};

export type ListSegmentOfOrganization = {
  /** The items in the current segment. */
  items: Array<Organization>;
  /** The total number of items. -1 if unspecified. */
  total: Scalars['Int']['output'];
};

export type ListSegmentOfPatient = {
  /** The items in the current segment. */
  items: Array<Patient>;
  /** The total number of items. -1 if unspecified. */
  total: Scalars['Int']['output'];
};

export type ListSegmentOfSpecialty = {
  items: Array<Specialty>;
  total: Scalars['Int']['output'];
};

export type MgRecurrence = {
  pattern: MgRecurrencePattern;
  period: MgRecurrencePeriod;
};

export type MgRecurrencePattern = {
  dayOfMonth: Maybe<Scalars['Int']['output']>;
  daysOfWeek: Maybe<Array<DayOfWeek>>;
  firstDayOfWeek: Maybe<DayOfWeek>;
  index: Maybe<MgRecurrenceRelativeIndex>;
  interval: Scalars['Int']['output'];
  month: Maybe<Scalars['Int']['output']>;
  type: RecurrenceType;
};

export type MgRecurrencePeriod = {
  end: Maybe<Scalars['LocalDate']['output']>;
  numberOfOccurrences: Maybe<Scalars['Int']['output']>;
  start: Scalars['LocalDate']['output'];
};

export type MgRecurrenceRelativeIndex = 'First' | 'Fourth' | 'Last' | 'Second' | 'Third';

export type NextOfKin = {
  email: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  relationship: Maybe<NextOfKinRelationship>;
};

export type NextOfKinRelationship =
  | 'CARER'
  | 'CHILD'
  | 'FRIEND'
  | 'OTHER'
  | 'PARENT'
  | 'PARTNER'
  | 'SIBLING'
  | 'SPOUSE';

export type NotificationSetting = {
  email: Scalars['Boolean']['output'];
  internal: Scalars['Boolean']['output'];
  type: NotificationType;
};

export type NotificationType =
  | 'AppointmentCancelledByPatient'
  | 'AppointmentCancelledByProvider'
  | 'AppointmentCreatedByPatient'
  | 'AppointmentCreatedByProvider'
  | 'ChatMessageReceived'
  | 'ConsentFormAssignedCareHomeStaff'
  | 'ConsentFormAssignedPatient'
  | 'ConsentFormSignedCoordinator'
  | 'ConsentFormSignedPerformer'
  | 'DocumentSignRequired'
  | 'FileSharedWithPatient'
  | 'TreatmentPlanEditRequest'
  | 'VisitCancelledCareHomeStaff'
  | 'VisitCancelledCoordinator'
  | 'VisitCancelledPatient'
  | 'VisitCancelledPerformer'
  | 'VisitDueInFourteenDaysCareHomeStaff'
  | 'VisitDueInFourteenDaysPatient'
  | 'VisitDueInOneDayCareHomeStaff'
  | 'VisitDueInOneDayPatient'
  | 'VisitDueInTwoDaysCareHomeStaff'
  | 'VisitDueInTwoDaysPatient'
  | 'VisitRequestedCoordinator'
  | 'VisitScheduledCareHomeStaff'
  | 'VisitScheduledCoordinator'
  | 'VisitScheduledPatient'
  | 'VisitScheduledPerformer';

export type Organization = {
  billingContacts: OrganizationContactInfo;
  contacts: OrganizationContactInfo;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  twoFactorLoginRequired: Maybe<Scalars['Boolean']['output']>;
};

export type OrganizationContactInfo = {
  address: Address;
  contactPersonName: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
};

export type Patient = {
  account: Maybe<UserAccount>;
  address: Address;
  avatar: Maybe<Scalars['String']['output']>;
  careHome: Maybe<CatalogCareHome>;
  careHomeId: Maybe<Scalars['UUID']['output']>;
  connection: Maybe<Connection>;
  contacts: PatientContactInfo;
  dateOfBirth: Scalars['DateTime']['output'];
  domiciliaryReason: Maybe<PatientDomiciliaryReason>;
  firstName: Scalars['String']['output'];
  fundingType: Maybe<PatientFundingType>;
  generalPractitioner: Maybe<PatientGeneralPractitioner>;
  gosNote: Maybe<Scalars['String']['output']>;
  hasAccount: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  /** True when the patient's recall date has passed and no scheduled upcoming appointment exists. */
  isOverdue: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  /** The most recent encounter for this patient; null if none. */
  latestEncounter: Maybe<Encounter>;
  nextOfKin: Array<NextOfKin>;
  nhsNumber: Maybe<Scalars['String']['output']>;
  niNumber: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  organizationId: Scalars['UUID']['output'];
  resourceId: Maybe<Scalars['String']['output']>;
  sex: Sex;
  status: PatientStatus;
  threadExists: Scalars['Boolean']['output'];
  title: Maybe<PatientTitle>;
};

export type PatientContactInfo = {
  additionalPhone: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
};

export type PatientDomiciliaryReason = 'CARE_HOME_RESIDENT' | 'HOUSEBOUND' | 'OTHER' | 'PHYSICAL_DISABILITY';

export type PatientFundingType = 'CORPORATE' | 'NHS' | 'PRIVATE';

export type PatientGeneralPractitioner = {
  gpName: Maybe<Scalars['String']['output']>;
  practiceAddress: Maybe<PatientGpPracticeAddress>;
  practiceEmail: Maybe<Scalars['String']['output']>;
  practiceName: Maybe<Scalars['String']['output']>;
  practicePhone: Maybe<Scalars['String']['output']>;
};

export type PatientGpPracticeAddress = {
  city: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  line2: Maybe<Scalars['String']['output']>;
  region: Maybe<Scalars['String']['output']>;
  street: Maybe<Scalars['String']['output']>;
  zipCode: Maybe<Scalars['String']['output']>;
};

export type PatientStatus = 'ACTIVE' | 'INACTIVE';

export type PatientTitle = 'DR' | 'MISS' | 'MR' | 'MRS' | 'MS' | 'PROF';

export type PeriodOfDateTimeOffset = {
  end: Scalars['DateTime']['output'];
  start: Scalars['DateTime']['output'];
};

export type PeriodOfDateTimeOffsetInput = {
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
};

export type ProviderInfo = {
  job: Scalars['String']['output'];
  providerRating: Maybe<ProviderRating>;
  specialty: Maybe<Specialty>;
  specialtyId: Maybe<Scalars['UUID']['output']>;
};

export type ProviderRating = {
  averageRating: Scalars['Float']['output'];
  count: Scalars['Int']['output'];
};

export type ProviderSettings = {
  organizationId: Scalars['UUID']['output'];
  providerId: Scalars['UUID']['output'];
};

export type Query = {
  appointmentEvent: Maybe<AppointmentEvent>;
  appointmentEvents: Array<AppointmentEvent>;
  appointmentEventsCount: Scalars['Int']['output'];
  appointmentEventsDailyStatusesCount: Array<AppointmentDailyEventsStatusCount>;
  appointmentEventsStatusesCount: Array<AppointmentEventsStatusCount>;
  appointmentRequest: Maybe<AppointmentRequest>;
  appointmentRequests: Array<AppointmentRequest>;
  appointmentTypeTemplate: AppointmentTypeTemplate;
  appointmentTypeTemplates: Array<AppointmentTypeTemplate>;
  availabilities: Array<Availability>;
  careHomesListSegment: ListSegmentOfCatalogCareHome;
  catalogCareHome: Maybe<CatalogCareHome>;
  catalogCareHomeCount: Scalars['Int']['output'];
  catalogCareHomes: Array<CatalogCareHome>;
  consent: Maybe<Consent>;
  consentTemplate: Maybe<ConsentTemplate>;
  consentTemplates: Array<ConsentTemplate>;
  consents: Array<Consent>;
  consentsCount: Scalars['Int']['output'];
  currentUser: Maybe<User>;
  documentTag: Maybe<DocumentTag>;
  documentTagCount: Scalars['Int']['output'];
  documentTags: Array<DocumentTag>;
  employee: Maybe<Employee>;
  employees: Array<Employee>;
  employeesById: Array<Employee>;
  encounter: Maybe<Encounter>;
  encounterByAppointmentEventId: Maybe<Encounter>;
  encounterCount: Scalars['Int']['output'];
  encounterTemplate: Maybe<EncounterTemplate>;
  encounterTemplateRoots: Array<Scalars['String']['output']>;
  encounterTemplates: Array<EncounterTemplate>;
  encounters: Array<Encounter>;
  firstAppointmentEventByAppointmentId: Maybe<AppointmentEvent>;
  hostPreferencesByHostId: Maybe<HostPreferences>;
  organization: Organization;
  organizationsListSegment: ListSegmentOfOrganization;
  patient: Patient;
  patientsListSegment: ListSegmentOfPatient;
  providerSettings: Maybe<ProviderSettings>;
  providerSettingsCount: Scalars['Int']['output'];
  searchProvider: Array<Employee>;
  searchProvidersByPatient: Array<Employee>;
  slots: Array<Maybe<HostSlotList>>;
  specialties: Array<Specialty>;
  specialtiesListSegment: ListSegmentOfSpecialty;
  specialty: Maybe<Specialty>;
  specialtyCount: Scalars['Int']['output'];
  user: Maybe<User>;
  users: Array<User>;
};

export type QueryAppointmentEventArgs = {
  id: Scalars['String']['input'];
};

export type QueryAppointmentEventsArgs = {
  careHomeIds: InputMaybe<Array<Scalars['String']['input']>>;
  from: Scalars['DateTime']['input'];
  hostIds: InputMaybe<Array<Scalars['String']['input']>>;
  statuses: InputMaybe<Array<AppointmentEventStatus>>;
  to: Scalars['DateTime']['input'];
  visitorIds: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryAppointmentEventsCountArgs = {
  careHomeIds: InputMaybe<Array<Scalars['String']['input']>>;
  from: Scalars['DateTime']['input'];
  hostIds: InputMaybe<Array<Scalars['String']['input']>>;
  statuses: InputMaybe<Array<AppointmentEventStatus>>;
  to: Scalars['DateTime']['input'];
  visitorIds: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryAppointmentEventsDailyStatusesCountArgs = {
  careHomeIds: InputMaybe<Array<Scalars['String']['input']>>;
  from: Scalars['DateTime']['input'];
  hostIds: InputMaybe<Array<Scalars['String']['input']>>;
  statuses: InputMaybe<Array<AppointmentEventStatus>>;
  to: Scalars['DateTime']['input'];
  visitorIds: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryAppointmentEventsStatusesCountArgs = {
  careHomeIds: InputMaybe<Array<Scalars['String']['input']>>;
  from: Scalars['DateTime']['input'];
  hostIds: InputMaybe<Array<Scalars['String']['input']>>;
  statuses: InputMaybe<Array<AppointmentEventStatus>>;
  to: Scalars['DateTime']['input'];
  visitorIds: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryAppointmentRequestArgs = {
  id: Scalars['String']['input'];
};

export type QueryAppointmentRequestsArgs = {
  query: InputMaybe<Scalars['JSON']['input']>;
};

export type QueryAppointmentTypeTemplateArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryAppointmentTypeTemplatesArgs = {
  filter: InputMaybe<Scalars['String']['input']>;
};

export type QueryAvailabilitiesArgs = {
  from: Scalars['DateTime']['input'];
  hostIds: Array<Scalars['String']['input']>;
  to: Scalars['DateTime']['input'];
};

export type QueryCareHomesListSegmentArgs = {
  query: InputMaybe<Scalars['JSON']['input']>;
  total?: Scalars['Boolean']['input'];
};

export type QueryCatalogCareHomeArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryCatalogCareHomeCountArgs = {
  filterRule: InputMaybe<Scalars['JSON']['input']>;
};

export type QueryCatalogCareHomesArgs = {
  query: InputMaybe<Scalars['String']['input']>;
};

export type QueryConsentArgs = {
  id: Scalars['String']['input'];
};

export type QueryConsentTemplateArgs = {
  id: Scalars['String']['input'];
};

export type QueryConsentTemplatesArgs = {
  filter: InputMaybe<Scalars['String']['input']>;
};

export type QueryConsentsArgs = {
  filter: InputMaybe<Scalars['String']['input']>;
};

export type QueryConsentsCountArgs = {
  filter: InputMaybe<Scalars['String']['input']>;
};

export type QueryDocumentTagArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryDocumentTagCountArgs = {
  filterRule: InputMaybe<Scalars['JSON']['input']>;
};

export type QueryDocumentTagsArgs = {
  query: InputMaybe<Scalars['String']['input']>;
};

export type QueryEmployeeArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryEmployeesArgs = {
  filter: InputMaybe<Scalars['String']['input']>;
};

export type QueryEmployeesByIdArgs = {
  ids: Array<Scalars['UUID']['input']>;
};

export type QueryEncounterArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryEncounterByAppointmentEventIdArgs = {
  appointmentEventId: Scalars['String']['input'];
};

export type QueryEncounterCountArgs = {
  filter: InputMaybe<Scalars['String']['input']>;
};

export type QueryEncounterTemplateArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryEncounterTemplateRootsArgs = {
  filter: InputMaybe<Scalars['String']['input']>;
};

export type QueryEncounterTemplatesArgs = {
  filter: InputMaybe<Scalars['String']['input']>;
};

export type QueryEncountersArgs = {
  careHomeIds: InputMaybe<Array<Scalars['UUID']['input']>>;
  hasClaim: InputMaybe<Scalars['Boolean']['input']>;
  ids: InputMaybe<Array<Scalars['UUID']['input']>>;
  patientIds: InputMaybe<Array<Scalars['UUID']['input']>>;
  period: InputMaybe<PeriodOfDateTimeOffsetInput>;
  providerIds: InputMaybe<Array<Scalars['UUID']['input']>>;
  specialtyIds: InputMaybe<Array<Scalars['UUID']['input']>>;
  statuses: InputMaybe<Array<EncounterStatus>>;
};

export type QueryFirstAppointmentEventByAppointmentIdArgs = {
  appointmentId: Scalars['String']['input'];
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};

export type QueryHostPreferencesByHostIdArgs = {
  hostId: Scalars['String']['input'];
};

export type QueryOrganizationArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryOrganizationsListSegmentArgs = {
  query: InputMaybe<Scalars['JSON']['input']>;
  total?: Scalars['Boolean']['input'];
};

export type QueryPatientArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryPatientsListSegmentArgs = {
  query: InputMaybe<Scalars['JSON']['input']>;
  searchValue: InputMaybe<Scalars['String']['input']>;
  total?: Scalars['Boolean']['input'];
};

export type QueryProviderSettingsArgs = {
  providerId: Scalars['UUID']['input'];
  query: InputMaybe<Scalars['String']['input']>;
};

export type QueryProviderSettingsCountArgs = {
  filterRule: InputMaybe<Scalars['JSON']['input']>;
};

export type QuerySearchProviderArgs = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  from: InputMaybe<Scalars['DateTime']['input']>;
  specialtyId: InputMaybe<Scalars['UUID']['input']>;
  to: InputMaybe<Scalars['DateTime']['input']>;
};

export type QuerySearchProvidersByPatientArgs = {
  active: InputMaybe<Scalars['Boolean']['input']>;
  patientId: Scalars['UUID']['input'];
};

export type QuerySlotsArgs = {
  extra: InputMaybe<Scalars['JSON']['input']>;
  hostIds: InputMaybe<Array<Scalars['String']['input']>>;
  period: PeriodOfDateTimeOffsetInput;
};

export type QuerySpecialtiesArgs = {
  query: InputMaybe<Scalars['String']['input']>;
};

export type QuerySpecialtiesListSegmentArgs = {
  query: InputMaybe<Scalars['JSON']['input']>;
  total?: Scalars['Boolean']['input'];
};

export type QuerySpecialtyArgs = {
  id: Scalars['UUID']['input'];
};

export type QuerySpecialtyCountArgs = {
  filterRule: InputMaybe<Scalars['JSON']['input']>;
};

export type QueryUserArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryUsersArgs = {
  filter: InputMaybe<Scalars['String']['input']>;
};

export type Recurrence = {
  mgRecurrence: Maybe<MgRecurrence>;
};

export type RecurrenceType =
  | 'AbsoluteMonthly'
  | 'AbsoluteYearly'
  | 'Daily'
  | 'RelativeMonthly'
  | 'RelativeYearly'
  | 'Weekly';

export type Sex = 'FEMALE' | 'MALE' | 'OTHER' | 'PREFER_NOT_TO_SAY';

export type Slot = {
  period: PeriodOfDateTimeOffset;
};

export type Specialty = {
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['UUID']['output'];
};

export type User = IUser & {
  account: Maybe<UserAccount>;
  active: Scalars['Boolean']['output'];
  avatar: Maybe<Scalars['String']['output']>;
  careHomeId: Maybe<Scalars['UUID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  lastName: Scalars['String']['output'];
  locale: Scalars['String']['output'];
  notificationSettings: Array<NotificationSetting>;
  organizationId: Scalars['UUID']['output'];
  phone: Maybe<Scalars['String']['output']>;
  roles: Array<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type UserAccount = {
  creating: Scalars['Boolean']['output'];
  emailConfirmed: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['UUID']['output'];
  isActive: Maybe<Scalars['Boolean']['output']>;
  passwordLockedOut: Maybe<Scalars['Boolean']['output']>;
};

export type VisitorRefGraphQl = {
  appointmentType: Maybe<AppointmentTypeTemplate>;
  referenceId: Maybe<Scalars['String']['output']>;
  visitor: Patient;
  visitorId: Scalars['String']['output'];
};

export type AddressFragment = {
  street: string;
  city: string;
  region: string | null;
  country: string;
  zipCode: string;
  line2: string | null;
};

type UserLookup_Employee_Fragment = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  avatar: string | null;
  active: boolean;
};

type UserLookup_User_Fragment = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  avatar: string | null;
  active: boolean;
};

export type UserLookupFragment = UserLookup_Employee_Fragment | UserLookup_User_Fragment;

export type ESignatureMetaFragment = { ipAddress: string | null };

export type ESignatureFragment = {
  timestamp: string;
  note: string | null;
  signature: string;
  signedById: string;
  meta: { ipAddress: string | null };
  signedBy: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    avatar: string | null;
    active: boolean;
  };
};

export type ConsentTemplateFragment = {
  id: string;
  name: string;
  description: string | null;
  data: string;
  isMandatory: boolean;
  isDefault: boolean;
  isAssigneeSignatureRequired: boolean;
  signatureType: ConsentSignatureType | null;
};

export type ConsentTemplateListItemFragment = {
  id: string;
  name: string;
  createdAt: string;
  createdBy: { id: string; firstName: string; lastName: string };
};

export type GetConsentTemplatesQueryVariables = Exact<{
  filter: InputMaybe<Scalars['String']['input']>;
}>;

export type GetConsentTemplatesQuery = {
  consentTemplates: Array<{
    id: string;
    name: string;
    createdAt: string;
    createdBy: { id: string; firstName: string; lastName: string };
  }>;
};

export type GetConsentTemplateQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetConsentTemplateQuery = {
  consentTemplate: {
    id: string;
    name: string;
    description: string | null;
    data: string;
    isMandatory: boolean;
    isDefault: boolean;
    isAssigneeSignatureRequired: boolean;
    signatureType: ConsentSignatureType | null;
  } | null;
};

export type UserDetailsFragment = { firstName: string; lastName: string };

export type ConsentFragment = {
  id: string;
  tenantId: string;
  assigneeId: string;
  referenceId: string;
  name: string;
  data: string;
  signatureType: ConsentSignatureType | null;
  createdAt: string;
  status: ConsentStatus;
  isMandatory: boolean;
  signedAt: string | null;
  version: string;
  createdBy: { firstName: string; lastName: string };
  signedBy: { firstName: string; lastName: string } | null;
  eSignature: {
    timestamp: string;
    note: string | null;
    signature: string;
    signedById: string;
    meta: { ipAddress: string | null };
    signedBy: {
      id: string;
      firstName: string;
      lastName: string;
      email: string;
      avatar: string | null;
      active: boolean;
    };
  } | null;
  signerDetails: {
    role: ConsentSignerRole;
    relation: string | null;
    name: string;
    address: {
      street: string | null;
      line2: string | null;
      city: string | null;
      region: string | null;
      country: string | null;
      zipCode: string | null;
    };
  } | null;
};

export type ConsentListItemFragment = {
  id: string;
  tenantId: string;
  assigneeId: string;
  referenceId: string;
  name: string;
  createdAt: string;
  status: ConsentStatus;
  signedAt: string | null;
  createdBy: { firstName: string; lastName: string };
  assignee: { firstName: string; lastName: string; status: PatientStatus } | null;
  signedBy: { firstName: string; lastName: string } | null;
  signerDetails: { role: ConsentSignerRole; name: string } | null;
  eSignature: {
    timestamp: string;
    note: string | null;
    signature: string;
    signedById: string;
    meta: { ipAddress: string | null };
    signedBy: {
      id: string;
      firstName: string;
      lastName: string;
      email: string;
      avatar: string | null;
      active: boolean;
    };
  } | null;
};

export type GetConsentsQueryVariables = Exact<{
  filter: InputMaybe<Scalars['String']['input']>;
}>;

export type GetConsentsQuery = {
  consents: Array<{
    id: string;
    tenantId: string;
    assigneeId: string;
    referenceId: string;
    name: string;
    createdAt: string;
    status: ConsentStatus;
    signedAt: string | null;
    createdBy: { firstName: string; lastName: string };
    assignee: { firstName: string; lastName: string; status: PatientStatus } | null;
    signedBy: { firstName: string; lastName: string } | null;
    signerDetails: { role: ConsentSignerRole; name: string } | null;
    eSignature: {
      timestamp: string;
      note: string | null;
      signature: string;
      signedById: string;
      meta: { ipAddress: string | null };
      signedBy: {
        id: string;
        firstName: string;
        lastName: string;
        email: string;
        avatar: string | null;
        active: boolean;
      };
    } | null;
  }>;
};

export type GetConsentQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetConsentQuery = {
  consent: {
    id: string;
    tenantId: string;
    assigneeId: string;
    referenceId: string;
    name: string;
    data: string;
    signatureType: ConsentSignatureType | null;
    createdAt: string;
    status: ConsentStatus;
    isMandatory: boolean;
    signedAt: string | null;
    version: string;
    createdBy: { firstName: string; lastName: string };
    signedBy: { firstName: string; lastName: string } | null;
    eSignature: {
      timestamp: string;
      note: string | null;
      signature: string;
      signedById: string;
      meta: { ipAddress: string | null };
      signedBy: {
        id: string;
        firstName: string;
        lastName: string;
        email: string;
        avatar: string | null;
        active: boolean;
      };
    } | null;
    signerDetails: {
      role: ConsentSignerRole;
      relation: string | null;
      name: string;
      address: {
        street: string | null;
        line2: string | null;
        city: string | null;
        region: string | null;
        country: string | null;
        zipCode: string | null;
      };
    } | null;
  } | null;
};

export type GetConsentExportDataQueryVariables = Exact<{
  id: Scalars['String']['input'];
  tenantId: Scalars['UUID']['input'];
  assigneeId: Scalars['UUID']['input'];
}>;

export type GetConsentExportDataQuery = {
  consent: {
    id: string;
    tenantId: string;
    assigneeId: string;
    referenceId: string;
    name: string;
    data: string;
    signatureType: ConsentSignatureType | null;
    createdAt: string;
    status: ConsentStatus;
    isMandatory: boolean;
    signedAt: string | null;
    version: string;
    createdBy: { firstName: string; lastName: string };
    signedBy: { firstName: string; lastName: string } | null;
    eSignature: {
      timestamp: string;
      note: string | null;
      signature: string;
      signedById: string;
      meta: { ipAddress: string | null };
      signedBy: {
        id: string;
        firstName: string;
        lastName: string;
        email: string;
        avatar: string | null;
        active: boolean;
      };
    } | null;
    signerDetails: {
      role: ConsentSignerRole;
      relation: string | null;
      name: string;
      address: {
        street: string | null;
        line2: string | null;
        city: string | null;
        region: string | null;
        country: string | null;
        zipCode: string | null;
      };
    } | null;
  } | null;
  organization: {
    twoFactorLoginRequired: boolean | null;
    id: string;
    name: string;
    contacts: {
      phone: string;
      email: string | null;
      contactPersonName: string | null;
      address: {
        street: string;
        city: string;
        region: string | null;
        country: string;
        zipCode: string;
        line2: string | null;
      };
    };
    billingContacts: {
      phone: string;
      email: string | null;
      contactPersonName: string | null;
      address: {
        street: string;
        city: string;
        region: string | null;
        country: string;
        zipCode: string;
        line2: string | null;
      };
    };
  };
  patient: {
    id: string;
    firstName: string;
    lastName: string;
    dateOfBirth: string;
    sex: Sex;
    status: PatientStatus;
    avatar: string | null;
    title: PatientTitle | null;
    careHomeId: string | null;
    niNumber: string | null;
    gosNote: string | null;
    fundingType: PatientFundingType | null;
    domiciliaryReason: PatientDomiciliaryReason | null;
    resourceId: string | null;
    number: string;
    address: {
      street: string;
      city: string;
      region: string | null;
      country: string;
      zipCode: string;
      line2: string | null;
    };
    contacts: { phone: string; additionalPhone: string | null; email: string | null };
    nextOfKin: Array<{
      firstName: string;
      lastName: string;
      email: string | null;
      phone: string;
      relationship: NextOfKinRelationship | null;
    }>;
    account: {
      id: string;
      emailConfirmed: boolean | null;
      isActive: boolean | null;
      passwordLockedOut: boolean | null;
      creating: boolean;
    } | null;
    connection: { chatId: string } | null;
  };
};

export type GetConsentsCountQueryVariables = Exact<{
  filter: InputMaybe<Scalars['String']['input']>;
}>;

export type GetConsentsCountQuery = { consentsCount: number };

export type DocumentTagFragment = { id: string; name: string };

export type GetDocumentTagsQueryVariables = Exact<{
  query: InputMaybe<Scalars['String']['input']>;
}>;

export type GetDocumentTagsQuery = { documentTags: Array<{ id: string; name: string }> };

export type HostPreferencesFragment = { defaultAppointmentDurationMinutes: number };

export type ProviderInfoFragment = {
  job: string;
  specialtyId: string | null;
  specialty: { id: string; name: string } | null;
  providerRating: { averageRating: number; count: number } | null;
};

export type EmployeeFragment = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string | null;
  roles: Array<string>;
  avatar: string | null;
  careHomeId: string | null;
  account: {
    id: string;
    emailConfirmed: boolean | null;
    isActive: boolean | null;
    passwordLockedOut: boolean | null;
    creating: boolean;
  } | null;
  providerInfo: {
    job: string;
    specialtyId: string | null;
    specialty: { id: string; name: string } | null;
    providerRating: { averageRating: number; count: number } | null;
  } | null;
  appointmentHostPreferences: { defaultAppointmentDurationMinutes: number } | null;
};

export type GetEmployeeLookupsQueryVariables = Exact<{
  filter: InputMaybe<Scalars['String']['input']>;
}>;

export type GetEmployeeLookupsQuery = {
  employees: Array<{
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    avatar: string | null;
    active: boolean;
  }>;
};

export type GetEmployeeListQueryVariables = Exact<{
  filter: InputMaybe<Scalars['String']['input']>;
}>;

export type GetEmployeeListQuery = {
  employees: Array<{
    id: string;
    firstName: string;
    lastName: string;
    avatar: string | null;
    email: string;
    phone: string | null;
    roles: Array<string>;
    account: {
      id: string;
      emailConfirmed: boolean | null;
      isActive: boolean | null;
      passwordLockedOut: boolean | null;
      creating: boolean;
    } | null;
  }>;
};

export type GetEmployeeQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type GetEmployeeQuery = {
  employee: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    phone: string | null;
    roles: Array<string>;
    avatar: string | null;
    careHomeId: string | null;
    account: {
      id: string;
      emailConfirmed: boolean | null;
      isActive: boolean | null;
      passwordLockedOut: boolean | null;
      creating: boolean;
    } | null;
    providerInfo: {
      job: string;
      specialtyId: string | null;
      specialty: { id: string; name: string } | null;
      providerRating: { averageRating: number; count: number } | null;
    } | null;
    appointmentHostPreferences: { defaultAppointmentDurationMinutes: number } | null;
  } | null;
};

export type EmployeeOverviewFragment = {
  id: string;
  firstName: string;
  lastName: string;
  avatar: string | null;
  email: string;
  phone: string | null;
  active: boolean;
  providerInfo: {
    specialty: {
      id: string;
      name: string;
      description: string | null;
      createdAt: string;
      archived: boolean;
      organizationId: string;
    } | null;
    providerRating: { averageRating: number; count: number } | null;
  } | null;
};

export type GetEmployeeOverviewQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type GetEmployeeOverviewQuery = {
  employee: {
    id: string;
    firstName: string;
    lastName: string;
    avatar: string | null;
    email: string;
    phone: string | null;
    active: boolean;
    providerInfo: {
      specialty: {
        id: string;
        name: string;
        description: string | null;
        createdAt: string;
        archived: boolean;
        organizationId: string;
      } | null;
      providerRating: { averageRating: number; count: number } | null;
    } | null;
  } | null;
};

export type CommonOrganizationInfoFragment = {
  id: string;
  name: string;
  twoFactorLoginRequired: boolean | null;
  contacts: {
    phone: string;
    email: string | null;
    contactPersonName: string | null;
    address: {
      street: string;
      city: string;
      region: string | null;
      country: string;
      zipCode: string;
      line2: string | null;
    };
  };
  billingContacts: {
    phone: string;
    email: string | null;
    contactPersonName: string | null;
    address: {
      street: string;
      city: string;
      region: string | null;
      country: string;
      zipCode: string;
      line2: string | null;
    };
  };
};

export type OrganizationFragment = {
  twoFactorLoginRequired: boolean | null;
  id: string;
  name: string;
  contacts: {
    phone: string;
    email: string | null;
    contactPersonName: string | null;
    address: {
      street: string;
      city: string;
      region: string | null;
      country: string;
      zipCode: string;
      line2: string | null;
    };
  };
  billingContacts: {
    phone: string;
    email: string | null;
    contactPersonName: string | null;
    address: {
      street: string;
      city: string;
      region: string | null;
      country: string;
      zipCode: string;
      line2: string | null;
    };
  };
};

export type OrganizationContactInfoFragment = {
  phone: string;
  email: string | null;
  contactPersonName: string | null;
  address: {
    street: string;
    city: string;
    region: string | null;
    country: string;
    zipCode: string;
    line2: string | null;
  };
};

export type GetOrganizationQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type GetOrganizationQuery = {
  organization: {
    twoFactorLoginRequired: boolean | null;
    id: string;
    name: string;
    contacts: {
      phone: string;
      email: string | null;
      contactPersonName: string | null;
      address: {
        street: string;
        city: string;
        region: string | null;
        country: string;
        zipCode: string;
        line2: string | null;
      };
    };
    billingContacts: {
      phone: string;
      email: string | null;
      contactPersonName: string | null;
      address: {
        street: string;
        city: string;
        region: string | null;
        country: string;
        zipCode: string;
        line2: string | null;
      };
    };
  };
};

export type GetOrganizationsListSegmentQueryVariables = Exact<{
  query: InputMaybe<Scalars['JSON']['input']>;
}>;

export type GetOrganizationsListSegmentQuery = {
  organizationsListSegment: {
    total: number;
    items: Array<{
      id: string;
      name: string;
      twoFactorLoginRequired: boolean | null;
      contacts: {
        phone: string;
        email: string | null;
        contactPersonName: string | null;
        address: {
          street: string;
          city: string;
          region: string | null;
          country: string;
          zipCode: string;
          line2: string | null;
        };
      };
      billingContacts: {
        phone: string;
        email: string | null;
        contactPersonName: string | null;
        address: {
          street: string;
          city: string;
          region: string | null;
          country: string;
          zipCode: string;
          line2: string | null;
        };
      };
    }>;
  };
};

export type PatientContactsFragment = { phone: string; additionalPhone: string | null; email: string | null };

export type PatientNextOfKinFragment = {
  firstName: string;
  lastName: string;
  email: string | null;
  phone: string;
  relationship: NextOfKinRelationship | null;
};

export type PatientGpPracticeAddressFragment = {
  street: string | null;
  city: string | null;
  region: string | null;
  country: string | null;
  zipCode: string | null;
  line2: string | null;
};

export type PatientGeneralPractitionerFragment = {
  gpName: string | null;
  practiceName: string | null;
  practiceEmail: string | null;
  practicePhone: string | null;
  practiceAddress: {
    street: string | null;
    city: string | null;
    region: string | null;
    country: string | null;
    zipCode: string | null;
    line2: string | null;
  } | null;
};

export type PatientFragment = {
  id: string;
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  sex: Sex;
  status: PatientStatus;
  avatar: string | null;
  title: PatientTitle | null;
  careHomeId: string | null;
  niNumber: string | null;
  gosNote: string | null;
  fundingType: PatientFundingType | null;
  domiciliaryReason: PatientDomiciliaryReason | null;
  resourceId: string | null;
  number: string;
  address: {
    street: string;
    city: string;
    region: string | null;
    country: string;
    zipCode: string;
    line2: string | null;
  };
  contacts: { phone: string; additionalPhone: string | null; email: string | null };
  nextOfKin: Array<{
    firstName: string;
    lastName: string;
    email: string | null;
    phone: string;
    relationship: NextOfKinRelationship | null;
  }>;
  account: {
    id: string;
    emailConfirmed: boolean | null;
    isActive: boolean | null;
    passwordLockedOut: boolean | null;
    creating: boolean;
  } | null;
  connection: { chatId: string } | null;
};

export type PatientDetailsFragment = {
  nhsNumber: string | null;
  id: string;
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  sex: Sex;
  status: PatientStatus;
  avatar: string | null;
  title: PatientTitle | null;
  careHomeId: string | null;
  niNumber: string | null;
  gosNote: string | null;
  fundingType: PatientFundingType | null;
  domiciliaryReason: PatientDomiciliaryReason | null;
  resourceId: string | null;
  number: string;
  generalPractitioner: {
    gpName: string | null;
    practiceName: string | null;
    practiceEmail: string | null;
    practicePhone: string | null;
    practiceAddress: {
      street: string | null;
      city: string | null;
      region: string | null;
      country: string | null;
      zipCode: string | null;
      line2: string | null;
    } | null;
  } | null;
  address: {
    street: string;
    city: string;
    region: string | null;
    country: string;
    zipCode: string;
    line2: string | null;
  };
  contacts: { phone: string; additionalPhone: string | null; email: string | null };
  nextOfKin: Array<{
    firstName: string;
    lastName: string;
    email: string | null;
    phone: string;
    relationship: NextOfKinRelationship | null;
  }>;
  account: {
    id: string;
    emailConfirmed: boolean | null;
    isActive: boolean | null;
    passwordLockedOut: boolean | null;
    creating: boolean;
  } | null;
  connection: { chatId: string } | null;
};

export type PatientLookupFragment = {
  id: string;
  firstName: string;
  lastName: string;
  status: PatientStatus;
  address: {
    street: string;
    city: string;
    region: string | null;
    country: string;
    zipCode: string;
    line2: string | null;
  };
  careHome: {
    id: string;
    name: string;
    type: CatalogCareHomeType;
    address: {
      street: string;
      city: string;
      region: string | null;
      country: string;
      zipCode: string;
      line2: string | null;
    } | null;
  } | null;
};

export type PatientIdLookupFragment = { id: string };

export type CareHomeDashboardPatientSummaryFragment = { id: string; isOverdue: boolean };

export type GetPatientLookupsListSegmentQueryVariables = Exact<{
  query: InputMaybe<Scalars['JSON']['input']>;
}>;

export type GetPatientLookupsListSegmentQuery = {
  patientsListSegment: {
    items: Array<{
      id: string;
      firstName: string;
      lastName: string;
      status: PatientStatus;
      address: {
        street: string;
        city: string;
        region: string | null;
        country: string;
        zipCode: string;
        line2: string | null;
      };
      careHome: {
        id: string;
        name: string;
        type: CatalogCareHomeType;
        address: {
          street: string;
          city: string;
          region: string | null;
          country: string;
          zipCode: string;
          line2: string | null;
        } | null;
      } | null;
    }>;
  };
};

export type GetPatientIdsByCareHomeListSegmentQueryVariables = Exact<{
  query: InputMaybe<Scalars['JSON']['input']>;
}>;

export type GetPatientIdsByCareHomeListSegmentQuery = {
  patientsListSegment: { items: Array<{ id: string }> };
};

export type GetPatientLookupQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type GetPatientLookupQuery = {
  patient: {
    id: string;
    firstName: string;
    lastName: string;
    status: PatientStatus;
    address: {
      street: string;
      city: string;
      region: string | null;
      country: string;
      zipCode: string;
      line2: string | null;
    };
    careHome: {
      id: string;
      name: string;
      type: CatalogCareHomeType;
      address: {
        street: string;
        city: string;
        region: string | null;
        country: string;
        zipCode: string;
        line2: string | null;
      } | null;
    } | null;
  };
};

export type GetPatientQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type GetPatientQuery = {
  patient: {
    nhsNumber: string | null;
    id: string;
    firstName: string;
    lastName: string;
    dateOfBirth: string;
    sex: Sex;
    status: PatientStatus;
    avatar: string | null;
    title: PatientTitle | null;
    careHomeId: string | null;
    niNumber: string | null;
    gosNote: string | null;
    fundingType: PatientFundingType | null;
    domiciliaryReason: PatientDomiciliaryReason | null;
    resourceId: string | null;
    number: string;
    generalPractitioner: {
      gpName: string | null;
      practiceName: string | null;
      practiceEmail: string | null;
      practicePhone: string | null;
      practiceAddress: {
        street: string | null;
        city: string | null;
        region: string | null;
        country: string | null;
        zipCode: string | null;
        line2: string | null;
      } | null;
    } | null;
    address: {
      street: string;
      city: string;
      region: string | null;
      country: string;
      zipCode: string;
      line2: string | null;
    };
    contacts: { phone: string; additionalPhone: string | null; email: string | null };
    nextOfKin: Array<{
      firstName: string;
      lastName: string;
      email: string | null;
      phone: string;
      relationship: NextOfKinRelationship | null;
    }>;
    account: {
      id: string;
      emailConfirmed: boolean | null;
      isActive: boolean | null;
      passwordLockedOut: boolean | null;
      creating: boolean;
    } | null;
    connection: { chatId: string } | null;
  };
};

export type GetPatientsListSegmentQueryVariables = Exact<{
  searchValue: InputMaybe<Scalars['String']['input']>;
  query: InputMaybe<Scalars['JSON']['input']>;
}>;

export type GetPatientsListSegmentQuery = {
  patientsListSegment: {
    total: number;
    items: Array<{
      id: string;
      firstName: string;
      lastName: string;
      dateOfBirth: string;
      sex: Sex;
      status: PatientStatus;
      avatar: string | null;
      title: PatientTitle | null;
      careHomeId: string | null;
      niNumber: string | null;
      gosNote: string | null;
      fundingType: PatientFundingType | null;
      domiciliaryReason: PatientDomiciliaryReason | null;
      resourceId: string | null;
      number: string;
      address: {
        street: string;
        city: string;
        region: string | null;
        country: string;
        zipCode: string;
        line2: string | null;
      };
      contacts: { phone: string; additionalPhone: string | null; email: string | null };
      nextOfKin: Array<{
        firstName: string;
        lastName: string;
        email: string | null;
        phone: string;
        relationship: NextOfKinRelationship | null;
      }>;
      account: {
        id: string;
        emailConfirmed: boolean | null;
        isActive: boolean | null;
        passwordLockedOut: boolean | null;
        creating: boolean;
      } | null;
      connection: { chatId: string } | null;
    }>;
  };
};

export type GetCareHomeDashboardPatientSummariesQueryVariables = Exact<{
  query: InputMaybe<Scalars['JSON']['input']>;
}>;

export type GetCareHomeDashboardPatientSummariesQuery = {
  patientsListSegment: { items: Array<{ id: string; isOverdue: boolean }> };
};

export type MyProviderFragment = {
  id: string;
  firstName: string;
  lastName: string;
  avatar: string | null;
  email: string;
  phone: string | null;
  active: boolean;
  connection: { chatId: string } | null;
  providerInfo: {
    providerRating: { averageRating: number; count: number } | null;
    specialty: {
      id: string;
      name: string;
      description: string | null;
      createdAt: string;
      archived: boolean;
      organizationId: string;
    } | null;
  } | null;
  lastAppointment: { last: { period: { start: string } } } | null;
};

export type ProviderSettingsFragment = { providerId: string; organizationId: string };

export type SearchProviderQueryVariables = Exact<{
  from: InputMaybe<Scalars['DateTime']['input']>;
  to: InputMaybe<Scalars['DateTime']['input']>;
  specialtyId: InputMaybe<Scalars['UUID']['input']>;
  active: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type SearchProviderQuery = {
  searchProvider: Array<{
    id: string;
    firstName: string;
    lastName: string;
    avatar: string | null;
    email: string;
    phone: string | null;
    active: boolean;
    providerInfo: {
      specialty: {
        id: string;
        name: string;
        description: string | null;
        createdAt: string;
        archived: boolean;
        organizationId: string;
      } | null;
      providerRating: { averageRating: number; count: number } | null;
    } | null;
  }>;
};

export type GetProviderHostPreferencesQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type GetProviderHostPreferencesQuery = {
  employee: { appointmentHostPreferences: { defaultAppointmentDurationMinutes: number } | null } | null;
};

export type SearchProvidersByPatientQueryVariables = Exact<{
  patientId: Scalars['UUID']['input'];
  active: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type SearchProvidersByPatientQuery = {
  searchProvidersByPatient: Array<{
    id: string;
    firstName: string;
    lastName: string;
    avatar: string | null;
    email: string;
    phone: string | null;
    active: boolean;
    connection: { chatId: string } | null;
    providerInfo: {
      providerRating: { averageRating: number; count: number } | null;
      specialty: {
        id: string;
        name: string;
        description: string | null;
        createdAt: string;
        archived: boolean;
        organizationId: string;
      } | null;
    } | null;
    lastAppointment: { last: { period: { start: string } } } | null;
  }>;
};

export type GetProviderSettingsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;

export type GetProviderSettingsQuery = {
  providerSettings: { providerId: string; organizationId: string } | null;
};

export type SpecialtyFragment = {
  id: string;
  name: string;
  description: string | null;
  createdAt: string;
  archived: boolean;
  organizationId: string;
};

export type GetSpecialtiesListSegmentQueryVariables = Exact<{
  query: InputMaybe<Scalars['JSON']['input']>;
}>;

export type GetSpecialtiesListSegmentQuery = {
  specialtiesListSegment: {
    total: number;
    items: Array<{
      id: string;
      name: string;
      description: string | null;
      createdAt: string;
      archived: boolean;
      organizationId: string;
    }>;
  };
};

export type UserAccountFragment = {
  id: string;
  emailConfirmed: boolean | null;
  isActive: boolean | null;
  passwordLockedOut: boolean | null;
  creating: boolean;
};

export type UserFragment = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  avatar: string | null;
  organizationId: string;
  roles: Array<string>;
  locale: string;
  careHomeId: string | null;
  notificationSettings: Array<{ type: NotificationType; internal: boolean; email: boolean }>;
};

export type GetUserLookupsQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserLookupsQuery = {
  users: Array<{
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    avatar: string | null;
    active: boolean;
  }>;
};

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never }>;

export type GetCurrentUserQuery = {
  currentUser: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    avatar: string | null;
    organizationId: string;
    roles: Array<string>;
    locale: string;
    careHomeId: string | null;
    notificationSettings: Array<{ type: NotificationType; internal: boolean; email: boolean }>;
  } | null;
};

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const ConsentTemplateFragmentDoc = new TypedDocumentString(
  `
    fragment ConsentTemplate on ConsentTemplate {
  id
  name
  description
  data
  isMandatory
  isDefault
  isAssigneeSignatureRequired
  signatureType
}
    `,
  { fragmentName: 'ConsentTemplate' },
) as unknown as TypedDocumentString<ConsentTemplateFragment, unknown>;
export const ConsentTemplateListItemFragmentDoc = new TypedDocumentString(
  `
    fragment ConsentTemplateListItem on ConsentTemplate {
  id
  name
  createdAt
  createdBy {
    id
    firstName
    lastName
  }
}
    `,
  { fragmentName: 'ConsentTemplateListItem' },
) as unknown as TypedDocumentString<ConsentTemplateListItemFragment, unknown>;
export const UserDetailsFragmentDoc = new TypedDocumentString(
  `
    fragment UserDetails on User {
  firstName
  lastName
}
    `,
  { fragmentName: 'UserDetails' },
) as unknown as TypedDocumentString<UserDetailsFragment, unknown>;
export const ESignatureMetaFragmentDoc = new TypedDocumentString(
  `
    fragment ESignatureMeta on ESignatureMeta {
  ipAddress
}
    `,
  { fragmentName: 'ESignatureMeta' },
) as unknown as TypedDocumentString<ESignatureMetaFragment, unknown>;
export const UserLookupFragmentDoc = new TypedDocumentString(
  `
    fragment UserLookup on IUser {
  id
  firstName
  lastName
  email
  avatar
  active
}
    `,
  { fragmentName: 'UserLookup' },
) as unknown as TypedDocumentString<UserLookupFragment, unknown>;
export const ESignatureFragmentDoc = new TypedDocumentString(
  `
    fragment ESignature on ESignature {
  timestamp
  note
  signature
  meta {
    ...ESignatureMeta
  }
  signedById
  signedBy {
    ...UserLookup
  }
}
    fragment UserLookup on IUser {
  id
  firstName
  lastName
  email
  avatar
  active
}
fragment ESignatureMeta on ESignatureMeta {
  ipAddress
}`,
  { fragmentName: 'ESignature' },
) as unknown as TypedDocumentString<ESignatureFragment, unknown>;
export const ConsentFragmentDoc = new TypedDocumentString(
  `
    fragment Consent on Consent {
  id
  tenantId
  assigneeId
  referenceId
  name
  data
  signatureType
  createdBy {
    ...UserDetails
  }
  createdAt
  status
  isMandatory
  signedAt
  signedBy {
    firstName
    lastName
  }
  eSignature {
    ...ESignature
  }
  signerDetails {
    role
    relation
    name
    address {
      street
      line2
      city
      region
      country
      zipCode
    }
  }
  version
}
    fragment UserLookup on IUser {
  id
  firstName
  lastName
  email
  avatar
  active
}
fragment ESignatureMeta on ESignatureMeta {
  ipAddress
}
fragment ESignature on ESignature {
  timestamp
  note
  signature
  meta {
    ...ESignatureMeta
  }
  signedById
  signedBy {
    ...UserLookup
  }
}
fragment UserDetails on User {
  firstName
  lastName
}`,
  { fragmentName: 'Consent' },
) as unknown as TypedDocumentString<ConsentFragment, unknown>;
export const ConsentListItemFragmentDoc = new TypedDocumentString(
  `
    fragment ConsentListItem on Consent {
  id
  tenantId
  assigneeId
  referenceId
  name
  createdAt
  createdBy {
    ...UserDetails
  }
  assignee {
    firstName
    lastName
    status
  }
  status
  signedAt
  signedBy {
    firstName
    lastName
  }
  signerDetails {
    role
    name
  }
  eSignature {
    ...ESignature
  }
}
    fragment UserLookup on IUser {
  id
  firstName
  lastName
  email
  avatar
  active
}
fragment ESignatureMeta on ESignatureMeta {
  ipAddress
}
fragment ESignature on ESignature {
  timestamp
  note
  signature
  meta {
    ...ESignatureMeta
  }
  signedById
  signedBy {
    ...UserLookup
  }
}
fragment UserDetails on User {
  firstName
  lastName
}`,
  { fragmentName: 'ConsentListItem' },
) as unknown as TypedDocumentString<ConsentListItemFragment, unknown>;
export const DocumentTagFragmentDoc = new TypedDocumentString(
  `
    fragment DocumentTag on DocumentTag {
  id
  name
}
    `,
  { fragmentName: 'DocumentTag' },
) as unknown as TypedDocumentString<DocumentTagFragment, unknown>;
export const HostPreferencesFragmentDoc = new TypedDocumentString(
  `
    fragment HostPreferences on HostPreferences {
  defaultAppointmentDurationMinutes
}
    `,
  { fragmentName: 'HostPreferences' },
) as unknown as TypedDocumentString<HostPreferencesFragment, unknown>;
export const UserAccountFragmentDoc = new TypedDocumentString(
  `
    fragment UserAccount on UserAccount {
  id
  emailConfirmed
  isActive
  passwordLockedOut
  creating
}
    `,
  { fragmentName: 'UserAccount' },
) as unknown as TypedDocumentString<UserAccountFragment, unknown>;
export const ProviderInfoFragmentDoc = new TypedDocumentString(
  `
    fragment ProviderInfo on ProviderInfo {
  job
  specialtyId
  specialty {
    id
    name
  }
  providerRating {
    averageRating
    count
  }
}
    `,
  { fragmentName: 'ProviderInfo' },
) as unknown as TypedDocumentString<ProviderInfoFragment, unknown>;
export const EmployeeFragmentDoc = new TypedDocumentString(
  `
    fragment Employee on Employee {
  id
  firstName
  lastName
  email
  phone
  roles
  avatar
  account {
    ...UserAccount
  }
  providerInfo {
    ...ProviderInfo
  }
  appointmentHostPreferences {
    defaultAppointmentDurationMinutes
  }
  careHomeId
}
    fragment ProviderInfo on ProviderInfo {
  job
  specialtyId
  specialty {
    id
    name
  }
  providerRating {
    averageRating
    count
  }
}
fragment UserAccount on UserAccount {
  id
  emailConfirmed
  isActive
  passwordLockedOut
  creating
}`,
  { fragmentName: 'Employee' },
) as unknown as TypedDocumentString<EmployeeFragment, unknown>;
export const SpecialtyFragmentDoc = new TypedDocumentString(
  `
    fragment Specialty on Specialty {
  id
  name
  description
  createdAt
  archived
  organizationId
}
    `,
  { fragmentName: 'Specialty' },
) as unknown as TypedDocumentString<SpecialtyFragment, unknown>;
export const EmployeeOverviewFragmentDoc = new TypedDocumentString(
  `
    fragment EmployeeOverview on Employee {
  id
  firstName
  lastName
  avatar
  email
  phone
  active
  providerInfo {
    specialty {
      ...Specialty
    }
    providerRating {
      averageRating
      count
    }
  }
}
    fragment Specialty on Specialty {
  id
  name
  description
  createdAt
  archived
  organizationId
}`,
  { fragmentName: 'EmployeeOverview' },
) as unknown as TypedDocumentString<EmployeeOverviewFragment, unknown>;
export const AddressFragmentDoc = new TypedDocumentString(
  `
    fragment Address on Address {
  street
  city
  region
  country
  zipCode
  line2
}
    `,
  { fragmentName: 'Address' },
) as unknown as TypedDocumentString<AddressFragment, unknown>;
export const OrganizationContactInfoFragmentDoc = new TypedDocumentString(
  `
    fragment OrganizationContactInfo on OrganizationContactInfo {
  address {
    ...Address
  }
  phone
  email
  contactPersonName
}
    fragment Address on Address {
  street
  city
  region
  country
  zipCode
  line2
}`,
  { fragmentName: 'OrganizationContactInfo' },
) as unknown as TypedDocumentString<OrganizationContactInfoFragment, unknown>;
export const CommonOrganizationInfoFragmentDoc = new TypedDocumentString(
  `
    fragment CommonOrganizationInfo on Organization {
  id
  name
  twoFactorLoginRequired
  contacts {
    ...OrganizationContactInfo
  }
  billingContacts {
    ...OrganizationContactInfo
  }
}
    fragment Address on Address {
  street
  city
  region
  country
  zipCode
  line2
}
fragment OrganizationContactInfo on OrganizationContactInfo {
  address {
    ...Address
  }
  phone
  email
  contactPersonName
}`,
  { fragmentName: 'CommonOrganizationInfo' },
) as unknown as TypedDocumentString<CommonOrganizationInfoFragment, unknown>;
export const OrganizationFragmentDoc = new TypedDocumentString(
  `
    fragment Organization on Organization {
  ...CommonOrganizationInfo
  twoFactorLoginRequired
}
    fragment Address on Address {
  street
  city
  region
  country
  zipCode
  line2
}
fragment CommonOrganizationInfo on Organization {
  id
  name
  twoFactorLoginRequired
  contacts {
    ...OrganizationContactInfo
  }
  billingContacts {
    ...OrganizationContactInfo
  }
}
fragment OrganizationContactInfo on OrganizationContactInfo {
  address {
    ...Address
  }
  phone
  email
  contactPersonName
}`,
  { fragmentName: 'Organization' },
) as unknown as TypedDocumentString<OrganizationFragment, unknown>;
export const PatientContactsFragmentDoc = new TypedDocumentString(
  `
    fragment PatientContacts on PatientContactInfo {
  phone
  additionalPhone
  email
}
    `,
  { fragmentName: 'PatientContacts' },
) as unknown as TypedDocumentString<PatientContactsFragment, unknown>;
export const PatientNextOfKinFragmentDoc = new TypedDocumentString(
  `
    fragment PatientNextOfKin on NextOfKin {
  firstName
  lastName
  email
  phone
  relationship
}
    `,
  { fragmentName: 'PatientNextOfKin' },
) as unknown as TypedDocumentString<PatientNextOfKinFragment, unknown>;
export const PatientFragmentDoc = new TypedDocumentString(
  `
    fragment Patient on Patient {
  id
  firstName
  lastName
  dateOfBirth
  sex
  status
  avatar
  title
  careHomeId
  niNumber
  gosNote
  fundingType
  domiciliaryReason
  resourceId
  address {
    ...Address
  }
  contacts {
    ...PatientContacts
  }
  nextOfKin {
    ...PatientNextOfKin
  }
  account {
    ...UserAccount
  }
  number
  connection {
    chatId
  }
}
    fragment Address on Address {
  street
  city
  region
  country
  zipCode
  line2
}
fragment PatientContacts on PatientContactInfo {
  phone
  additionalPhone
  email
}
fragment PatientNextOfKin on NextOfKin {
  firstName
  lastName
  email
  phone
  relationship
}
fragment UserAccount on UserAccount {
  id
  emailConfirmed
  isActive
  passwordLockedOut
  creating
}`,
  { fragmentName: 'Patient' },
) as unknown as TypedDocumentString<PatientFragment, unknown>;
export const PatientGpPracticeAddressFragmentDoc = new TypedDocumentString(
  `
    fragment PatientGpPracticeAddress on PatientGpPracticeAddress {
  street
  city
  region
  country
  zipCode
  line2
}
    `,
  { fragmentName: 'PatientGpPracticeAddress' },
) as unknown as TypedDocumentString<PatientGpPracticeAddressFragment, unknown>;
export const PatientGeneralPractitionerFragmentDoc = new TypedDocumentString(
  `
    fragment PatientGeneralPractitioner on PatientGeneralPractitioner {
  gpName
  practiceName
  practiceEmail
  practicePhone
  practiceAddress {
    ...PatientGpPracticeAddress
  }
}
    fragment PatientGpPracticeAddress on PatientGpPracticeAddress {
  street
  city
  region
  country
  zipCode
  line2
}`,
  { fragmentName: 'PatientGeneralPractitioner' },
) as unknown as TypedDocumentString<PatientGeneralPractitionerFragment, unknown>;
export const PatientDetailsFragmentDoc = new TypedDocumentString(
  `
    fragment PatientDetails on Patient {
  ...Patient
  nhsNumber
  generalPractitioner {
    ...PatientGeneralPractitioner
  }
}
    fragment Address on Address {
  street
  city
  region
  country
  zipCode
  line2
}
fragment PatientContacts on PatientContactInfo {
  phone
  additionalPhone
  email
}
fragment PatientNextOfKin on NextOfKin {
  firstName
  lastName
  email
  phone
  relationship
}
fragment PatientGpPracticeAddress on PatientGpPracticeAddress {
  street
  city
  region
  country
  zipCode
  line2
}
fragment PatientGeneralPractitioner on PatientGeneralPractitioner {
  gpName
  practiceName
  practiceEmail
  practicePhone
  practiceAddress {
    ...PatientGpPracticeAddress
  }
}
fragment Patient on Patient {
  id
  firstName
  lastName
  dateOfBirth
  sex
  status
  avatar
  title
  careHomeId
  niNumber
  gosNote
  fundingType
  domiciliaryReason
  resourceId
  address {
    ...Address
  }
  contacts {
    ...PatientContacts
  }
  nextOfKin {
    ...PatientNextOfKin
  }
  account {
    ...UserAccount
  }
  number
  connection {
    chatId
  }
}
fragment UserAccount on UserAccount {
  id
  emailConfirmed
  isActive
  passwordLockedOut
  creating
}`,
  { fragmentName: 'PatientDetails' },
) as unknown as TypedDocumentString<PatientDetailsFragment, unknown>;
export const PatientLookupFragmentDoc = new TypedDocumentString(
  `
    fragment PatientLookup on Patient {
  id
  firstName
  lastName
  status
  address {
    street
    city
    region
    country
    zipCode
    line2
  }
  careHome {
    id
    name
    type
    address {
      street
      city
      region
      country
      zipCode
      line2
    }
  }
}
    `,
  { fragmentName: 'PatientLookup' },
) as unknown as TypedDocumentString<PatientLookupFragment, unknown>;
export const PatientIdLookupFragmentDoc = new TypedDocumentString(
  `
    fragment PatientIdLookup on Patient {
  id
}
    `,
  { fragmentName: 'PatientIdLookup' },
) as unknown as TypedDocumentString<PatientIdLookupFragment, unknown>;
export const CareHomeDashboardPatientSummaryFragmentDoc = new TypedDocumentString(
  `
    fragment CareHomeDashboardPatientSummary on Patient {
  id
  isOverdue
}
    `,
  { fragmentName: 'CareHomeDashboardPatientSummary' },
) as unknown as TypedDocumentString<CareHomeDashboardPatientSummaryFragment, unknown>;
export const MyProviderFragmentDoc = new TypedDocumentString(
  `
    fragment MyProvider on Employee {
  id
  firstName
  lastName
  avatar
  email
  phone
  active
  connection {
    chatId
  }
  providerInfo {
    providerRating {
      averageRating
      count
    }
    specialty {
      ...Specialty
    }
  }
  lastAppointment {
    last {
      period {
        start
      }
    }
  }
}
    fragment Specialty on Specialty {
  id
  name
  description
  createdAt
  archived
  organizationId
}`,
  { fragmentName: 'MyProvider' },
) as unknown as TypedDocumentString<MyProviderFragment, unknown>;
export const ProviderSettingsFragmentDoc = new TypedDocumentString(
  `
    fragment ProviderSettings on ProviderSettings {
  providerId
  organizationId
}
    `,
  { fragmentName: 'ProviderSettings' },
) as unknown as TypedDocumentString<ProviderSettingsFragment, unknown>;
export const UserFragmentDoc = new TypedDocumentString(
  `
    fragment User on User {
  id
  firstName
  lastName
  email
  avatar
  organizationId
  roles
  locale
  careHomeId
  notificationSettings {
    type
    internal
    email
  }
}
    `,
  { fragmentName: 'User' },
) as unknown as TypedDocumentString<UserFragment, unknown>;
export const GetConsentTemplatesDocument = new TypedDocumentString(`
    query getConsentTemplates($filter: String) {
  consentTemplates(filter: $filter) {
    ...ConsentTemplateListItem
  }
}
    fragment ConsentTemplateListItem on ConsentTemplate {
  id
  name
  createdAt
  createdBy {
    id
    firstName
    lastName
  }
}`) as unknown as TypedDocumentString<GetConsentTemplatesQuery, GetConsentTemplatesQueryVariables>;
export const GetConsentTemplateDocument = new TypedDocumentString(`
    query getConsentTemplate($id: String!) {
  consentTemplate(id: $id) {
    ...ConsentTemplate
  }
}
    fragment ConsentTemplate on ConsentTemplate {
  id
  name
  description
  data
  isMandatory
  isDefault
  isAssigneeSignatureRequired
  signatureType
}`) as unknown as TypedDocumentString<GetConsentTemplateQuery, GetConsentTemplateQueryVariables>;
export const GetConsentsDocument = new TypedDocumentString(`
    query getConsents($filter: String) {
  consents(filter: $filter) {
    ...ConsentListItem
  }
}
    fragment UserLookup on IUser {
  id
  firstName
  lastName
  email
  avatar
  active
}
fragment ESignatureMeta on ESignatureMeta {
  ipAddress
}
fragment ESignature on ESignature {
  timestamp
  note
  signature
  meta {
    ...ESignatureMeta
  }
  signedById
  signedBy {
    ...UserLookup
  }
}
fragment UserDetails on User {
  firstName
  lastName
}
fragment ConsentListItem on Consent {
  id
  tenantId
  assigneeId
  referenceId
  name
  createdAt
  createdBy {
    ...UserDetails
  }
  assignee {
    firstName
    lastName
    status
  }
  status
  signedAt
  signedBy {
    firstName
    lastName
  }
  signerDetails {
    role
    name
  }
  eSignature {
    ...ESignature
  }
}`) as unknown as TypedDocumentString<GetConsentsQuery, GetConsentsQueryVariables>;
export const GetConsentDocument = new TypedDocumentString(`
    query getConsent($id: String!) {
  consent(id: $id) {
    ...Consent
  }
}
    fragment UserLookup on IUser {
  id
  firstName
  lastName
  email
  avatar
  active
}
fragment ESignatureMeta on ESignatureMeta {
  ipAddress
}
fragment ESignature on ESignature {
  timestamp
  note
  signature
  meta {
    ...ESignatureMeta
  }
  signedById
  signedBy {
    ...UserLookup
  }
}
fragment UserDetails on User {
  firstName
  lastName
}
fragment Consent on Consent {
  id
  tenantId
  assigneeId
  referenceId
  name
  data
  signatureType
  createdBy {
    ...UserDetails
  }
  createdAt
  status
  isMandatory
  signedAt
  signedBy {
    firstName
    lastName
  }
  eSignature {
    ...ESignature
  }
  signerDetails {
    role
    relation
    name
    address {
      street
      line2
      city
      region
      country
      zipCode
    }
  }
  version
}`) as unknown as TypedDocumentString<GetConsentQuery, GetConsentQueryVariables>;
export const GetConsentExportDataDocument = new TypedDocumentString(`
    query getConsentExportData($id: String!, $tenantId: UUID!, $assigneeId: UUID!) {
  consent(id: $id) {
    ...Consent
  }
  organization(id: $tenantId) {
    ...Organization
  }
  patient(id: $assigneeId) {
    ...Patient
  }
}
    fragment Address on Address {
  street
  city
  region
  country
  zipCode
  line2
}
fragment UserLookup on IUser {
  id
  firstName
  lastName
  email
  avatar
  active
}
fragment ESignatureMeta on ESignatureMeta {
  ipAddress
}
fragment ESignature on ESignature {
  timestamp
  note
  signature
  meta {
    ...ESignatureMeta
  }
  signedById
  signedBy {
    ...UserLookup
  }
}
fragment UserDetails on User {
  firstName
  lastName
}
fragment Consent on Consent {
  id
  tenantId
  assigneeId
  referenceId
  name
  data
  signatureType
  createdBy {
    ...UserDetails
  }
  createdAt
  status
  isMandatory
  signedAt
  signedBy {
    firstName
    lastName
  }
  eSignature {
    ...ESignature
  }
  signerDetails {
    role
    relation
    name
    address {
      street
      line2
      city
      region
      country
      zipCode
    }
  }
  version
}
fragment CommonOrganizationInfo on Organization {
  id
  name
  twoFactorLoginRequired
  contacts {
    ...OrganizationContactInfo
  }
  billingContacts {
    ...OrganizationContactInfo
  }
}
fragment Organization on Organization {
  ...CommonOrganizationInfo
  twoFactorLoginRequired
}
fragment OrganizationContactInfo on OrganizationContactInfo {
  address {
    ...Address
  }
  phone
  email
  contactPersonName
}
fragment PatientContacts on PatientContactInfo {
  phone
  additionalPhone
  email
}
fragment PatientNextOfKin on NextOfKin {
  firstName
  lastName
  email
  phone
  relationship
}
fragment Patient on Patient {
  id
  firstName
  lastName
  dateOfBirth
  sex
  status
  avatar
  title
  careHomeId
  niNumber
  gosNote
  fundingType
  domiciliaryReason
  resourceId
  address {
    ...Address
  }
  contacts {
    ...PatientContacts
  }
  nextOfKin {
    ...PatientNextOfKin
  }
  account {
    ...UserAccount
  }
  number
  connection {
    chatId
  }
}
fragment UserAccount on UserAccount {
  id
  emailConfirmed
  isActive
  passwordLockedOut
  creating
}`) as unknown as TypedDocumentString<GetConsentExportDataQuery, GetConsentExportDataQueryVariables>;
export const GetConsentsCountDocument = new TypedDocumentString(`
    query getConsentsCount($filter: String) {
  consentsCount(filter: $filter)
}
    `) as unknown as TypedDocumentString<GetConsentsCountQuery, GetConsentsCountQueryVariables>;
export const GetDocumentTagsDocument = new TypedDocumentString(`
    query getDocumentTags($query: String) {
  documentTags(query: $query) {
    ...DocumentTag
  }
}
    fragment DocumentTag on DocumentTag {
  id
  name
}`) as unknown as TypedDocumentString<GetDocumentTagsQuery, GetDocumentTagsQueryVariables>;
export const GetEmployeeLookupsDocument = new TypedDocumentString(`
    query getEmployeeLookups($filter: String) {
  employees(filter: $filter) {
    ...UserLookup
  }
}
    fragment UserLookup on IUser {
  id
  firstName
  lastName
  email
  avatar
  active
}`) as unknown as TypedDocumentString<GetEmployeeLookupsQuery, GetEmployeeLookupsQueryVariables>;
export const GetEmployeeListDocument = new TypedDocumentString(`
    query getEmployeeList($filter: String) {
  employees(filter: $filter) {
    id
    firstName
    lastName
    avatar
    email
    phone
    roles
    account {
      ...UserAccount
    }
  }
}
    fragment UserAccount on UserAccount {
  id
  emailConfirmed
  isActive
  passwordLockedOut
  creating
}`) as unknown as TypedDocumentString<GetEmployeeListQuery, GetEmployeeListQueryVariables>;
export const GetEmployeeDocument = new TypedDocumentString(`
    query getEmployee($id: UUID!) {
  employee(id: $id) {
    ...Employee
  }
}
    fragment ProviderInfo on ProviderInfo {
  job
  specialtyId
  specialty {
    id
    name
  }
  providerRating {
    averageRating
    count
  }
}
fragment Employee on Employee {
  id
  firstName
  lastName
  email
  phone
  roles
  avatar
  account {
    ...UserAccount
  }
  providerInfo {
    ...ProviderInfo
  }
  appointmentHostPreferences {
    defaultAppointmentDurationMinutes
  }
  careHomeId
}
fragment UserAccount on UserAccount {
  id
  emailConfirmed
  isActive
  passwordLockedOut
  creating
}`) as unknown as TypedDocumentString<GetEmployeeQuery, GetEmployeeQueryVariables>;
export const GetEmployeeOverviewDocument = new TypedDocumentString(`
    query getEmployeeOverview($id: UUID!) {
  employee(id: $id) {
    ...EmployeeOverview
  }
}
    fragment EmployeeOverview on Employee {
  id
  firstName
  lastName
  avatar
  email
  phone
  active
  providerInfo {
    specialty {
      ...Specialty
    }
    providerRating {
      averageRating
      count
    }
  }
}
fragment Specialty on Specialty {
  id
  name
  description
  createdAt
  archived
  organizationId
}`) as unknown as TypedDocumentString<GetEmployeeOverviewQuery, GetEmployeeOverviewQueryVariables>;
export const GetOrganizationDocument = new TypedDocumentString(`
    query getOrganization($id: UUID!) {
  organization(id: $id) {
    ...Organization
  }
}
    fragment Address on Address {
  street
  city
  region
  country
  zipCode
  line2
}
fragment CommonOrganizationInfo on Organization {
  id
  name
  twoFactorLoginRequired
  contacts {
    ...OrganizationContactInfo
  }
  billingContacts {
    ...OrganizationContactInfo
  }
}
fragment Organization on Organization {
  ...CommonOrganizationInfo
  twoFactorLoginRequired
}
fragment OrganizationContactInfo on OrganizationContactInfo {
  address {
    ...Address
  }
  phone
  email
  contactPersonName
}`) as unknown as TypedDocumentString<GetOrganizationQuery, GetOrganizationQueryVariables>;
export const GetOrganizationsListSegmentDocument = new TypedDocumentString(`
    query getOrganizationsListSegment($query: JSON) {
  organizationsListSegment(query: $query) {
    items {
      ...CommonOrganizationInfo
    }
    total
  }
}
    fragment Address on Address {
  street
  city
  region
  country
  zipCode
  line2
}
fragment CommonOrganizationInfo on Organization {
  id
  name
  twoFactorLoginRequired
  contacts {
    ...OrganizationContactInfo
  }
  billingContacts {
    ...OrganizationContactInfo
  }
}
fragment OrganizationContactInfo on OrganizationContactInfo {
  address {
    ...Address
  }
  phone
  email
  contactPersonName
}`) as unknown as TypedDocumentString<
  GetOrganizationsListSegmentQuery,
  GetOrganizationsListSegmentQueryVariables
>;
export const GetPatientLookupsListSegmentDocument = new TypedDocumentString(`
    query getPatientLookupsListSegment($query: JSON) {
  patientsListSegment(query: $query, total: false) {
    items {
      ...PatientLookup
    }
  }
}
    fragment PatientLookup on Patient {
  id
  firstName
  lastName
  status
  address {
    street
    city
    region
    country
    zipCode
    line2
  }
  careHome {
    id
    name
    type
    address {
      street
      city
      region
      country
      zipCode
      line2
    }
  }
}`) as unknown as TypedDocumentString<
  GetPatientLookupsListSegmentQuery,
  GetPatientLookupsListSegmentQueryVariables
>;
export const GetPatientIdsByCareHomeListSegmentDocument = new TypedDocumentString(`
    query getPatientIdsByCareHomeListSegment($query: JSON) {
  patientsListSegment(query: $query, total: false) {
    items {
      ...PatientIdLookup
    }
  }
}
    fragment PatientIdLookup on Patient {
  id
}`) as unknown as TypedDocumentString<
  GetPatientIdsByCareHomeListSegmentQuery,
  GetPatientIdsByCareHomeListSegmentQueryVariables
>;
export const GetPatientLookupDocument = new TypedDocumentString(`
    query getPatientLookup($id: UUID!) {
  patient(id: $id) {
    ...PatientLookup
  }
}
    fragment PatientLookup on Patient {
  id
  firstName
  lastName
  status
  address {
    street
    city
    region
    country
    zipCode
    line2
  }
  careHome {
    id
    name
    type
    address {
      street
      city
      region
      country
      zipCode
      line2
    }
  }
}`) as unknown as TypedDocumentString<GetPatientLookupQuery, GetPatientLookupQueryVariables>;
export const GetPatientDocument = new TypedDocumentString(`
    query getPatient($id: UUID!) {
  patient(id: $id) {
    ...PatientDetails
  }
}
    fragment Address on Address {
  street
  city
  region
  country
  zipCode
  line2
}
fragment PatientContacts on PatientContactInfo {
  phone
  additionalPhone
  email
}
fragment PatientNextOfKin on NextOfKin {
  firstName
  lastName
  email
  phone
  relationship
}
fragment PatientGpPracticeAddress on PatientGpPracticeAddress {
  street
  city
  region
  country
  zipCode
  line2
}
fragment PatientGeneralPractitioner on PatientGeneralPractitioner {
  gpName
  practiceName
  practiceEmail
  practicePhone
  practiceAddress {
    ...PatientGpPracticeAddress
  }
}
fragment Patient on Patient {
  id
  firstName
  lastName
  dateOfBirth
  sex
  status
  avatar
  title
  careHomeId
  niNumber
  gosNote
  fundingType
  domiciliaryReason
  resourceId
  address {
    ...Address
  }
  contacts {
    ...PatientContacts
  }
  nextOfKin {
    ...PatientNextOfKin
  }
  account {
    ...UserAccount
  }
  number
  connection {
    chatId
  }
}
fragment PatientDetails on Patient {
  ...Patient
  nhsNumber
  generalPractitioner {
    ...PatientGeneralPractitioner
  }
}
fragment UserAccount on UserAccount {
  id
  emailConfirmed
  isActive
  passwordLockedOut
  creating
}`) as unknown as TypedDocumentString<GetPatientQuery, GetPatientQueryVariables>;
export const GetPatientsListSegmentDocument = new TypedDocumentString(`
    query getPatientsListSegment($searchValue: String, $query: JSON) {
  patientsListSegment(searchValue: $searchValue, query: $query) {
    items {
      ...Patient
    }
    total
  }
}
    fragment Address on Address {
  street
  city
  region
  country
  zipCode
  line2
}
fragment PatientContacts on PatientContactInfo {
  phone
  additionalPhone
  email
}
fragment PatientNextOfKin on NextOfKin {
  firstName
  lastName
  email
  phone
  relationship
}
fragment Patient on Patient {
  id
  firstName
  lastName
  dateOfBirth
  sex
  status
  avatar
  title
  careHomeId
  niNumber
  gosNote
  fundingType
  domiciliaryReason
  resourceId
  address {
    ...Address
  }
  contacts {
    ...PatientContacts
  }
  nextOfKin {
    ...PatientNextOfKin
  }
  account {
    ...UserAccount
  }
  number
  connection {
    chatId
  }
}
fragment UserAccount on UserAccount {
  id
  emailConfirmed
  isActive
  passwordLockedOut
  creating
}`) as unknown as TypedDocumentString<GetPatientsListSegmentQuery, GetPatientsListSegmentQueryVariables>;
export const GetCareHomeDashboardPatientSummariesDocument = new TypedDocumentString(`
    query getCareHomeDashboardPatientSummaries($query: JSON) {
  patientsListSegment(query: $query, total: false) {
    items {
      ...CareHomeDashboardPatientSummary
    }
  }
}
    fragment CareHomeDashboardPatientSummary on Patient {
  id
  isOverdue
}`) as unknown as TypedDocumentString<
  GetCareHomeDashboardPatientSummariesQuery,
  GetCareHomeDashboardPatientSummariesQueryVariables
>;
export const SearchProviderDocument = new TypedDocumentString(`
    query searchProvider($from: DateTime, $to: DateTime, $specialtyId: UUID, $active: Boolean) {
  searchProvider(from: $from, to: $to, specialtyId: $specialtyId, active: $active) {
    ...EmployeeOverview
  }
}
    fragment EmployeeOverview on Employee {
  id
  firstName
  lastName
  avatar
  email
  phone
  active
  providerInfo {
    specialty {
      ...Specialty
    }
    providerRating {
      averageRating
      count
    }
  }
}
fragment Specialty on Specialty {
  id
  name
  description
  createdAt
  archived
  organizationId
}`) as unknown as TypedDocumentString<SearchProviderQuery, SearchProviderQueryVariables>;
export const GetProviderHostPreferencesDocument = new TypedDocumentString(`
    query getProviderHostPreferences($id: UUID!) {
  employee(id: $id) {
    appointmentHostPreferences {
      ...HostPreferences
    }
  }
}
    fragment HostPreferences on HostPreferences {
  defaultAppointmentDurationMinutes
}`) as unknown as TypedDocumentString<
  GetProviderHostPreferencesQuery,
  GetProviderHostPreferencesQueryVariables
>;
export const SearchProvidersByPatientDocument = new TypedDocumentString(`
    query searchProvidersByPatient($patientId: UUID!, $active: Boolean) {
  searchProvidersByPatient(patientId: $patientId, active: $active) {
    ...MyProvider
  }
}
    fragment MyProvider on Employee {
  id
  firstName
  lastName
  avatar
  email
  phone
  active
  connection {
    chatId
  }
  providerInfo {
    providerRating {
      averageRating
      count
    }
    specialty {
      ...Specialty
    }
  }
  lastAppointment {
    last {
      period {
        start
      }
    }
  }
}
fragment Specialty on Specialty {
  id
  name
  description
  createdAt
  archived
  organizationId
}`) as unknown as TypedDocumentString<SearchProvidersByPatientQuery, SearchProvidersByPatientQueryVariables>;
export const GetProviderSettingsDocument = new TypedDocumentString(`
    query getProviderSettings($id: UUID!) {
  providerSettings(providerId: $id) {
    ...ProviderSettings
  }
}
    fragment ProviderSettings on ProviderSettings {
  providerId
  organizationId
}`) as unknown as TypedDocumentString<GetProviderSettingsQuery, GetProviderSettingsQueryVariables>;
export const GetSpecialtiesListSegmentDocument = new TypedDocumentString(`
    query getSpecialtiesListSegment($query: JSON) {
  specialtiesListSegment(query: $query) {
    items {
      ...Specialty
    }
    total
  }
}
    fragment Specialty on Specialty {
  id
  name
  description
  createdAt
  archived
  organizationId
}`) as unknown as TypedDocumentString<
  GetSpecialtiesListSegmentQuery,
  GetSpecialtiesListSegmentQueryVariables
>;
export const GetUserLookupsDocument = new TypedDocumentString(`
    query getUserLookups {
  users {
    ...UserLookup
  }
}
    fragment UserLookup on IUser {
  id
  firstName
  lastName
  email
  avatar
  active
}`) as unknown as TypedDocumentString<GetUserLookupsQuery, GetUserLookupsQueryVariables>;
export const GetCurrentUserDocument = new TypedDocumentString(`
    query getCurrentUser {
  currentUser {
    ...User
  }
}
    fragment User on User {
  id
  firstName
  lastName
  email
  avatar
  organizationId
  roles
  locale
  careHomeId
  notificationSettings {
    type
    internal
    email
  }
}`) as unknown as TypedDocumentString<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
